import { createFileRoute } from '@tanstack/react-router';

/** Forwards to `/people/:identityId` (see the parent route). */
export const Route = createFileRoute(
  '/_private/_route/_internal/candidates/$candidateId/suggested-pipelines/',
)({});
